import { render, staticRenderFns } from "./Grantors.vue?vue&type=template&id=433ac92c&scoped=true"
import script from "./Grantors.vue?vue&type=script&lang=js"
export * from "./Grantors.vue?vue&type=script&lang=js"
import style0 from "./Grantors.vue?vue&type=style&index=0&id=433ac92c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "433ac92c",
  null
  
)

export default component.exports